<template>
    <div
        v-if="visible"
        class="side-base-modal-mask"
        :class="[`is--${position}`]"
        @click.self="$emit('close')"
    >
        <div
            class="side-base-modal"
            @mousedown.stop
            @pointerdown.stop
            @touchstart.stop
        >
            <div class="side-base-modal__content">
                <div class="side-base-modal__header">
                    <slot name="header" />
                    <span
                        class="text-secondary-actions hover:text-active-elements cursor-pointer"
                        @click="$emit('close')"
                    >
                        <RedesignBaseIcon
                            name="X"
                            :size="20"
                        />
                    </span>
                </div>

                <div class="side-base-modal__body">
                    <slot />
                </div>


                <div class="side-base-modal__footer">
                    <slot name="footer" />
                </div>
            </div>
        </div>
    </div>
</template>


<script setup lang="ts">
import RedesignBaseIcon from '@/components/RedesignBaseComponents/RedesignBaseIcon.vue'

withDefaults(
    defineProps<{
        visible: boolean
        position?: 'left' | 'right'
    }>(),
    {
        position: 'right'
    }
)

defineEmits([ 'close' ])
</script>



<style lang="scss" scoped>
.side-base-modal {
  @apply w-[328px] ltr:pr-1 rtl:pl-1;
  background: var(--mainBgColor-color);
  box-shadow: -3px 0 12px 0 var(--gray-700);
  direction: ltr;

  &-mask {
      @apply fixed inset-0 w-screen h-screen overflow-hidden bg-transparent flex justify-end;
      z-index: var(--index-widget-dialog, 9999);
  }

  &-mask.is--right {
      @apply justify-end;
  }

  &-mask.is--left {
      @apply justify-start;
  }

  &__content {
      @apply flex flex-col max-w-full h-full;
  }

  &__header {
      @apply py-3 px-6 flex items-center justify-between border-b border-ui-lines gap-2 font-medium;
      height: calc(4rem + 2px);
  }

  &__body {
      @apply px-6 py-4 flex-grow overflow-y-auto;
  }

  &__footer {
      @apply py-4 px-6 flex items-center justify-end border-t border-ui-lines gap-3;
  }
}

[dir='rtl'] {
    .side-base-modal__content {
        direction: rtl;
    }
}
</style>


